import { useState } from "react";
import type { ReactNode } from "react";
import { Modal } from "react-bootstrap";

type ConfirmActionModalProps = {
  show: boolean;
  title?: string;
  message: ReactNode;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
};

const ConfirmActionModal = ({ show, title = "Confirmation required", message, confirmLabel = "Delete", onCancel, onConfirm }: ConfirmActionModalProps) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <Modal show={show} onHide={onCancel} centered animation={false} dialogClassName="tw-max-w-[487px] tw-w-full" contentClassName="!tw-rounded-lg !tw-border !tw-border-gray-200 !tw-p-0">
      <div className="tw-border-b tw-border-gray-200 tw-px-4 tw-py-4">
        <span className="tw-text-base tw-font-semibold tw-text-gray-900 tw-leading-6">{title}</span>
      </div>
      <div className="tw-px-4 tw-py-4">
        <p className="tw-m-0 tw-text-sm tw-text-gray-900">{message}</p>
      </div>
      <div className="tw-flex tw-justify-end tw-gap-3 tw-border-t tw-border-gray-200 tw-px-4 tw-py-3">
        <button type="button" className="tw-h-9 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-4 tw-text-sm tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed" onClick={onCancel} disabled={isConfirming}>
          Cancel
        </button>
        <button type="button" className="tw-h-9 tw-rounded-lg tw-border-0 tw-bg-error-500 tw-px-4 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-error-600 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed" onClick={handleConfirm} disabled={isConfirming}>
          {isConfirming ? "Please wait…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
